module.exports = __webpack_public_path__ + "static/media/Systems Analysis Workflow.c07f69f3.png";